import { notification } from "antd";
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { authService } from "../module/public/auth/service/auth.service";
import HttpStatusCode, { mConstants } from "./constants";
import storeService from "./store";

export const api = axios.create({
  baseURL: mConstants.API_URL,
});

export const authApi = axios.create({
  baseURL: mConstants.AUTH_API_URL,
});

// Public API - token шаардлагагүй
export const publicApi = axios.create({
  baseURL: mConstants.API_URL,
});

const excludeUrls = [
  `/ma/realms/${mConstants.REALM}/protocol/openid-connect/token`,
];

[api, authApi].forEach((element) => {
  element.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = storeService.getToken();

      if (config.headers != null && !excludeUrls.includes(config.url!)) {
        config.headers.Authorization = `Bearer ${token?.access_token}`;
      }

      return config;
    },
    (error: any) => {
      return Promise.reject(error.response);
    }
  );

  element.interceptors.response.use(
    (response: AxiosResponse) => {
      return response.data;
    },
    (error: AxiosError) => {
      let url: string = error.request.responseURL;

      if (
        error.response?.status === HttpStatusCode.UNAUTHORIZED &&
        !url.endsWith("/token")
      ) {
        authService.logout();

        notification["error"]({
          message: "Алдаа",
          description: "Таны session - ий хугацаа дууссан байна.",
        });
      } else if (error.response?.status !== HttpStatusCode.NOT_FOUND) {
        notification["error"]({
          message: "Алдаа",
          description:
            error.response?.data["message"] ??
            error.response?.data["error_description"],
        });
      }

      return Promise.reject(error.response?.data);
    }
  );
});

// Public API response interceptor - алдааны мэдэгдэл харуулах
publicApi.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error: AxiosError) => {
    if (error.response?.status !== HttpStatusCode.NOT_FOUND) {
      notification["error"]({
        message: "Алдаа",
        description:
          error.response?.data["message"] ??
          error.response?.data["error_description"] ??
          "Хүсэлт амжилтгүй боллоо",
      });
    }

    return Promise.reject(error.response?.data);
  }
);
